import React, { PureComponent } from "react";
import styled, { css, keyframes } from 'styled-components';
import Odometer from "react-odometerjs";

import "odometer/themes/odometer-theme-default.css";

import "./VerticalProgressBar.css";

/**
 * @desc Reports VerticalProgressBar Displaying component
 * @param props
 * @return null
 * @author Praveen George, Lakshmikanth V
 */
class VerticalProgressBar extends PureComponent { 
  render() {
    const keyFrames = keyframes`
      0% { width: 0%; }
      100% { width: ${this.props.percentage}%; }
    }`;

    const animation = () => css`
      ${keyFrames} 1s;
    `;

    let Style = styled.div`
    animation: ${animation} 2s linear infinite;
    width: ${this.props.percentage}%`;

    const progressFullClass = this.props.percentage === 100 ? " full-class ":'';

    return (
      <React.Fragment>
        <div className={"col-md-6 " + this.props.className}>							
          <div className="progress-wrap">
            <h3><Odometer 
              format="d" 
              duration={1000} 
              value={this.props.percentage} 
              />{ '%'}</h3>
            <p>{this.props.rejectionReason}</p>
            <div className="progress-outer">
              <Style percentage={this.props.percentage} className={"progress-bar red "  + this.props.rejectionReasonClass + progressFullClass} />
              {/* <div className={"progress-bar red "  + this.props.rejectionReasonClass} style={style}></div> */}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }  
};

export default VerticalProgressBar;



// WEBPACK FOOTER //
// ./src/components/UI/ReportsComponents/VerticalProgressBar/VerticalProgressBar.js